import { store } from 'store';
import { mapFeatureToPlatforms, mapToApiPlatform } from './mapper';

export const getPlatforms = (feature = 'contents') => {
  const platforms =
    store.getState().accountReducer.currentUser?.user?.permissions
      ?.SearchPlatforms;

  return mapFeatureToPlatforms[feature].filter((platform) =>
    Boolean(platforms[mapToApiPlatform[platform]]?.permission)
  );
};
